import { useMemo } from "react";

import { useAtomValue } from "jotai";
import { SelectItem } from "library/types";
import { selectedClientAtom } from "store";

import useEmployee from "hooks/useEmployee";
import { useGetMsalUserEmail } from "hooks/useGetMsalUserEmail";

import { SelectionTags } from "./SelectionTags/SelectionTags";

const PackageUserSelect = () => {
  const userUniqueEmail = useGetMsalUserEmail();

  const selectedClient = useAtomValue(selectedClientAtom);

  const { employeeData } = useEmployee();

  const packageUserOptions = useMemo(() => {
    const options = [] as SelectItem[];
    const employeeOptions = [] as SelectItem[];
    const dependentsOptions = [] as SelectItem[];
    if (!employeeData)
      return {
        options,
        employeeOptions,
        dependentsOptions,
      };

    employeeOptions.push({
      ...employeeData,
      value: userUniqueEmail || "",
      text: `${employeeData?.firstName} ${employeeData?.lastName}`,
      label: `${employeeData?.firstName} ${employeeData?.lastName}`,
    });
    employeeData?.dependents?.forEach((dependent) => {
      dependentsOptions.push({
        ...dependent,
        value: dependent.employeeDependentTag || "",
        text: `${dependent?.firstName} ${dependent?.lastName}`,
        label: `${dependent?.firstName} ${dependent?.lastName}`,
      });
    });
    return {
      options: [...employeeOptions, ...dependentsOptions],
      employeeOptions,
      dependentsOptions,
    };
  }, [employeeData?.firstName, selectedClient]);

  return <SelectionTags options={packageUserOptions.options} />;
};

export default PackageUserSelect;
